import reducer from './usersReducer';
import actions from './usersActions';
import createProvider from '../../utilities/createProvider';

export default createProvider(actions, reducer);
